/**
 * DeleteConfirmationDialog Component (Documents)
 * Simple confirmation dialog for deleting documents
 *
 * Migrated to BaseDialog pattern (Phase 3.2)
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';

import { BaseDialog } from '../ui/BaseDialog';

interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm
}) => {
  const { t } = useTranslation();

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title={t('documents.delete.title')}
      maxWidth="xs"
      actions={
        <>
          <Button onClick={onClose}>{t('documents.delete.cancel')}</Button>
          <Button onClick={onConfirm} color="error" variant="contained">
            {t('documents.delete.confirm')}
          </Button>
        </>
      }
    >
      <Typography>{t('documents.delete.message')}</Typography>
    </BaseDialog>
  );
};